module.exports = __webpack_public_path__ + "static/media/03_In-Transit_needHelp.3df8ddf1.jpg";